import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccessRightsService } from '../services/access-rights.service';
import { Policy } from '../../shared/models/info/policy';

@Directive({
  selector: '[appIfPolicySatisfied]',
})
export class IfPolicySatisfiedDirective implements OnDestroy {
  private subscription: Subscription | null = null;
  private accessRightsService: AccessRightsService = inject(AccessRightsService);

  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);

  @Input() public set appIfPolicySatisfied(policy: Policy) {
    this.subscription?.unsubscribe();
    this.subscription = this.accessRightsService.isPolicySatisfied$(policy).subscribe((satisfied) => {
      if (satisfied) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
